import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import { Bubble } from 'react-chartjs-2';

import { daysWeekLong, hoursSlotsForData } from 'utils/common';

import { BubbleChartContainer } from './style';

const BubbleChart = ({ data, bubbleChartStyle = {} }) => {
  const ref = useRef();

  const ballSizes = (value = 0) => {
    if (value > 0 && value <= 2) {
      return 4;
    }
    if (value > 2 && value <= 4) {
      return 8;
    }
    if (value > 4 && value <= 6) {
      return 12;
    }
    if (value > 6) {
      return 16;
    }
    return 0;
  };

  const parsedData = {
    datasets: [
      {
        data: []
      }
    ]
  };

  Object.keys(data).forEach(k => {
    data[k].forEach(val => {
      parsedData.datasets[0].data.push({
        x: daysWeekLong.findIndex(v => k === v) + 1,
        y: hoursSlotsForData.findIndex(v => v === val.interval) + 1,
        r: ballSizes(val.value),
        val: val.value
      });
    });
  });

  return (
    <BubbleChartContainer>
      <Bubble ref={ref} data={parsedData} options={bubbleChartStyle.options} />
    </BubbleChartContainer>
  );
};

BubbleChart.propTypes = {
  data: PropTypes.object,
  bubbleChartStyle: PropTypes.object
};

export default BubbleChart;
